module.exports = __webpack_public_path__ + "img/76.cf7fa641.jpg";